var STATUS_CLASSES = {
  noshow: "bg-sds-urgent-tertiary border-sds-urgent-secondary",
  cancelled: "bg-sds-disabled-default border-sds-disabled-secondary",
  "entered-in-error": "bg-sds-disabled-default border-sds-disabled-secondary",
  waitlist: "bg-sds-disabled-default border-sds-disabled-secondary",
  "checked-in": "bg-sds-success-secondary border-sds-success-default",
  arrived: "bg-sds-success-secondary border-sds-success-default",
  fulfilled: "bg-sds-success-tertiary border-sds-success-secondary",
  pending: "bg-sds-attention-tertiary border-sds-attention-secondary",
  proposed: "bg-sds-attention-tertiary border-sds-attention-secondary",
  booked: "bg-sds-base-secondary border-sds-base-default"
};
var DEFAULT_CLASSES = "bg-sds-base-secondary border-sds-base-default";

/** Returns the SDS background and border classes for the date box given an appointment status. */
export function getAppointmentStatusClasses(status) {
  var _STATUS_CLASSES$statu;
  return (_STATUS_CLASSES$statu = STATUS_CLASSES[status.toLowerCase()]) !== null && _STATUS_CLASSES$statu !== void 0 ? _STATUS_CLASSES$statu : DEFAULT_CLASSES;
}